/**
 * Labstep
 *
 * @module components/GroupAutoSharing/Action/Create
 */

import { GroupAutoSharingFormCreateContainer as GroupAutoSharingFormCreate } from 'labstep-web/components/GroupAutoSharing/Form/Create';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { GroupActionCreateProps } from './types';

export const GroupAutoSharingActionCreate: React.FC<
  GroupActionCreateProps
> = ({ sourceGroup, actionComponentProps }) => (
  <ModalDefault
    header="New Autosharing Rule"
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        onClick={toggleModal}
        text="Add Autosharing Rule"
        type="text"
        icon={ICONS.access_key.primary}
        {...actionComponentProps}
      />
    )}
    content={({ toggleModal }) => (
      <GroupAutoSharingFormCreate
        body={{
          source_group_id: sourceGroup.guid,
        }}
        options={{
          onSuccess: toggleModal,
          toast: true,
        }}
        sourceGroup={sourceGroup}
      />
    )}
  />
);
